/*
  Feedback visual del botón "Agregar al carrito".

  El tema ya hace AJAX add-to-cart y abre el drawer automáticamente al
  emitir el evento "ajaxProduct:added". Este script añade:
    - Texto "Añadiendo..." mientras la petición está en curso
    - Texto "✓ Añadido" brevemente al completar (antes de abrir drawer)
    - Restaura el texto original tras ~1.5s
*/
(function () {
  var ADDING_TEXT = 'Añadiendo…';
  var ADDED_TEXT = '✓ Añadido';
  var RESET_DELAY = 1500;

  function onAddClick(e) {
    var form = e.target.closest('form');
    if (!form) return;
    var btn = form.querySelector('[data-add-to-cart]');
    if (!btn || btn.disabled) return;
    var textEl = btn.querySelector('[data-add-to-cart-text]');
    if (!textEl) return;

    // Guardar texto original para restaurar después
    if (!btn.dataset.originalText) {
      btn.dataset.originalText = textEl.textContent.trim();
    }
    textEl.textContent = ADDING_TEXT;
    btn.classList.add('is-adding');
  }

  function onProductAdded(evt) {
    // Buscar el botón que disparó la adición (el del producto activo o el último clicado)
    var btn = evt.detail && evt.detail.addToCartBtn;
    if (!btn) {
      btn = document.querySelector('[data-add-to-cart].is-adding');
    }
    if (!btn) return;
    var textEl = btn.querySelector('[data-add-to-cart-text]');
    if (!textEl) return;

    btn.classList.remove('is-adding');
    btn.classList.add('is-added');
    textEl.textContent = ADDED_TEXT;

    setTimeout(function () {
      var original = btn.dataset.originalText;
      if (original) {
        textEl.textContent = original;
      }
      btn.classList.remove('is-added');
    }, RESET_DELAY);
  }

  function onProductError(evt) {
    var btn = evt.detail && evt.detail.addToCartBtn;
    if (!btn) {
      btn = document.querySelector('[data-add-to-cart].is-adding');
    }
    if (!btn) return;
    var textEl = btn.querySelector('[data-add-to-cart-text]');
    btn.classList.remove('is-adding');
    if (textEl && btn.dataset.originalText) {
      textEl.textContent = btn.dataset.originalText;
    }
  }

  // Delegación: capturar clicks en cualquier [data-add-to-cart] del documento.
  // No interferimos con el submit del form (lo gestiona theme.js para hacer AJAX).
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-add-to-cart]')) {
      onAddClick(e);
    }
  });

  document.addEventListener('ajaxProduct:added', onProductAdded);
  document.addEventListener('ajaxProduct:error', onProductError);
})();
